import { TrophyOutlined } from '@ant-design/icons'
import { Card, Form, Space, Tag, Typography } from 'antd'
import { LoyaltyTier } from '../../../../models/LoyaltyTier'
import Audience from '../../../audience/Audience'

const { Title, Text } = Typography

type Props = {
  loyaltyTier: LoyaltyTier
  viewOnly?: boolean
}

export const LoyaltyTierCard = ({ loyaltyTier, viewOnly }: Props) => {
  const form = Form.useFormInstance()
  const loyaltyTierWatch = Form.useWatch('loyaltyTier', form)

  const handleLoyaltyTierSelect = (loyaltyTierId: number) => {
    form.setFieldsValue({ loyaltyTier: loyaltyTierId })
  }

  const setLoyaltyTier = (loyaltyTierId: number) => {
    form.setFieldValue('loyaltyTier', loyaltyTierId)
    handleLoyaltyTierSelect(loyaltyTierId)
  }

  return (
    <Card
      key={loyaltyTier.id}
      onClick={() => !viewOnly && setLoyaltyTier(loyaltyTier.id)}
      style={{
        borderColor:
          loyaltyTierWatch === loyaltyTier.id ? '#8e978a' : undefined,
        borderWidth: loyaltyTierWatch === loyaltyTier.id ? 2 : 1,
        opacity: viewOnly && loyaltyTierWatch !== loyaltyTier.id ? 0.4 : 1,
        cursor: viewOnly ? undefined : 'pointer',
      }}
    >
      <Space orientation="horizontal" className="w-full space-between">
        <Space size={20}>
          <Text style={{ fontSize: 20 }}>
            <TrophyOutlined />
          </Text>
          <Space orientation="vertical" size={5}>
            <Tag color={loyaltyTier.color}>
              <Title level={5} className="m-0" style={{ color: 'unset' }}>
                {loyaltyTier.title}
              </Title>
            </Tag>
            <Text>
              All users in <b>{loyaltyTier.title}</b> tier and who subscribed to
              notifications in the application.
            </Text>
          </Space>
        </Space>
        <Audience.UsersCount
          showOnlySubscribedCount
          loyaltyTierId={loyaltyTier.id}
        />
      </Space>
    </Card>
  )
}
